var link_viewer_default = {
  "fontElementMap": "ZcI2N",
  "link": "_5ZPU7",
  "linkInEditor": "_2wZQf",
  "linkInViewer": "ULy0U",
  "toolbarUrlContainer": "_6vi9-",
  "toolbarUrl": "HYU3D",
  "toolbarUrlAnchor": "z56rg"
};
export {
  link_viewer_default as default
};
//# sourceMappingURL=link-viewer-scss.js.map
